// StepOne.js
import React from "react";

function StepOne({
  formData,
  formErrors,
  touched,
  validUserError,
  handleChange,
  handleBlur,
  showPassword,
  showConfirmPassword,
  togglePasswordVisibility,
  toggleConfirmPasswordVisibility,
}) {
  return (
    <>
      <div className="first-last-unique">
        <div className="form-group-unique">
          <label htmlFor="firstName">First Name</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {touched.firstName && formErrors.firstName && (
            <p className="error">{formErrors.firstName}</p>
          )}
        </div>
        <div className="form-group-unique">
          <label htmlFor="familyName">Family Name</label>
          <input
            type="text"
            id="familyName"
            name="familyName"
            value={formData.familyName}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {touched.familyName && formErrors.familyName && (
            <p className="error">{formErrors.familyName}</p>
          )}
        </div>
      </div>

      <div className="form-group-unique">
        <label htmlFor="company">Company Name</label>
        <input
          type="text"
          id="company"
          name="company"
          value={formData.company}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.company && formErrors.company && (
          <p className="error">{formErrors.company}</p>
        )}
      </div>

      <div className="form-group-unique">
        <label htmlFor="commercialRecord">Commercial Record</label>
        <input
          type="text"
          id="commercialRecord"
          name="commercialRecord"
          value={formData.commercialRecord}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.commercialRecord && formErrors.commercialRecord && (
          <p className="error">{formErrors.commercialRecord}</p>
        )}
      </div>

      <div className="form-group-unique">
        <label htmlFor="taxNumber">Tax Number</label>
        <input
          type="text"
          id="taxNumber"
          name="taxNumber"
          value={formData.taxNumber}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.taxNumber && formErrors.taxNumber && (
          <p className="error">{formErrors.taxNumber}</p>
        )}
      </div>
    </>
  );
}

export default StepOne;
